import React from 'react';
import { Label } from '@/components/ui/label';
import { RadioGroup, RadioGroupItem } from '@/components/ui/radio-group';

export type SoraModel = 'sora-2' | 'sora-2-pro';

interface ModelSelectorProps {
  value: SoraModel;
  onChange: (model: SoraModel) => void;
}

/**
 * ModelSelector - Choose between Sora 2 models
 *
 * Sora 2: Faster generation (~1 min)
 * Sora 2 Pro: Higher quality, slower (~2 min)
 */
export const ModelSelector: React.FC<ModelSelectorProps> = ({ value, onChange }) => {
  return (
    <div className="space-y-3">
      <Label>AI Model</Label>
      <RadioGroup value={value} onValueChange={(val) => onChange(val as SoraModel)}>
        <div className="space-y-2">
          <div className="flex items-center space-x-2">
            <RadioGroupItem value="sora-2" id="sora-2" />
            <Label htmlFor="sora-2" className="cursor-pointer flex items-center gap-2">
              <span className="font-semibold">Sora 2</span>
              <span className="text-xs text-muted-foreground">(Faster, ~1 minute)</span>
            </Label>
          </div>
          <div className="flex items-center space-x-2">
            <RadioGroupItem value="sora-2-pro" id="sora-2-pro" />
            <Label htmlFor="sora-2-pro" className="cursor-pointer flex items-center gap-2">
              <span className="font-semibold">Sora 2 Pro</span>
              <span className="text-xs text-muted-foreground">(Higher Quality, ~2 minutes)</span>
            </Label>
          </div>
        </div>
      </RadioGroup>
      <p className="text-xs text-muted-foreground">
        {value === 'sora-2'
          ? 'Balanced speed and quality for most use cases'
          : 'Premium quality for professional content'}
      </p>
    </div>
  );
};

export default ModelSelector;
